import { NavTreeItem } from '../../domains/navigationTree.domain';
import _ from 'lodash';

export const isInNavigationTree = (
	navigationTreeData: NavTreeItem[],
	itemToSearchFor: NavTreeItem
): boolean => {
	let matchedItem: NavTreeItem | undefined;
	matchedItem = _.find(navigationTreeData, (navigationItem: NavTreeItem) => {
		let isInSubpages = false;
		if (navigationItem.subpages && navigationItem.subpages.length > 0) {
			isInSubpages = isInNavigationTree(
				navigationItem.subpages,
				itemToSearchFor
			);
		}

		return itemToSearchFor.key === navigationItem.key || isInSubpages;
	});

	return matchedItem !== undefined;
};
